import React from 'react';
import { Route, Navigate, Routes } from 'react-router-dom';
import Home from '../pages/Home';
import Search from '../pages/Search';
import EventDetails from '../pages/EventDetails'
import EventDetails2 from '../pages/EventDetails2'
import Filters from '../pages/Filters'
import MyEvents from '../pages/MyEvents'
import MyEvents2 from '../pages/MyEvents2'
import ConflictEvents from '../pages/ConflictEvents'
import ConflictEvents2 from '../pages/ConflictEvents2'
import PersonalInformation from '../pages/PersonalInformation'
import Details from '../pages/Details'
import Details2 from '../pages/Details2'
import plat from '../pages/Plat';
import plat2 from '../pages/Plat2';
import plat3 from '../pages/Plat3';
import Empower from '../pages/empower';
import Country from '../pages/Country';
import UserList from '../pages/UserList';



const Routers: React.FC = () => {
    return (
        <Routes>
            <Route path='/home'  Component={Home} />
            <Route path='/search' Component={Search} />
            <Route path='/eventdetails' Component={EventDetails} />
            <Route path='/eventdetails2' Component={EventDetails2} />
            <Route path='/filters'  Component={Filters} />
            <Route path='/myevents' Component={MyEvents} />
            <Route path='/myevents2' Component={MyEvents2} />
            <Route path='/conflictEvents' Component={ConflictEvents} />
            <Route path='/conflictEvents2' Component={ConflictEvents2} />
            <Route path='/personalInformation' Component={PersonalInformation} />
            <Route path='/details' Component={Details} />
            <Route path='/details2' Component={Details2} />
            <Route path='/plat/:item' Component={plat} />
            <Route path='/plat2' Component={plat2} />
            <Route path='/plat3' Component={plat3} />
            <Route path='/empower' Component={Empower} />
            <Route path='/Country' Component={Country} />
            <Route path='/UserList' Component={UserList} />
            <Route path="*" element={<Navigate to="/empower" />} />
        </Routes>
    );
};

export default Routers;